import { formatDate as fullcalendarFormatDate } from '@fullcalendar/core'

const unitToMilliSeconds = {
  msec: 1,
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000,
  week: 604800000,
}

function parseDuration(duration) {
  const matches = duration.match(/^([+-]?\d+)\s*(msec|second|minute|hour|day|week|month|year)s?$/)
  if (!matches) throw 'invalid duration'
  return { multiply: Number(matches[1]), unit: matches[2] }
}

export const timeFormatOptions = {
  locale: 'ja',
  hour: '2-digit',
  minute: '2-digit',
}

export const dateFormatOptions = {
  locale: 'ja',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}

export const datetimeFormatOptions = {
  ...dateFormatOptions,
  ...timeFormatOptions,
}

export function parseDate(dateInput, defaultValue) {
  defaultValue = defaultValue || null
  if (Number.isInteger(dateInput)) {
    dateInput = new Date(dateInput)
  } else if (typeof dateInput === 'string') {
    const regex = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[T ](\d{1,2}):(\d{1,2}))?$/
    const matches = dateInput.match(regex)
    if (matches) {
      const year = parseInt(matches[1])
      const month = parseInt(matches[2]) - 1
      const date = parseInt(matches[3])
      const hours = matches[4] ? parseInt(matches[4]) : 0
      const minutes = matches[5] ? parseInt(matches[5]) : 0
      dateInput = new Date(year, month, date, hours, minutes)
    } else {
      return defaultValue
    }
  } else {
    return defaultValue
  }
  if (!dateInput) return defaultValue
  if (dateInput.toString() === 'Invalid Date') return defaultValue
  return dateInput
}

export function addDuration(date, duration) {
  if (Number.isInteger(duration)) {
    return new Date(date.getTime() + duration)
  }
  const { multiply, unit } = parseDuration(duration)
  if (unit !== 'year' && unit !== 'month') {
    return new Date(date.getTime() + unitToMilliSeconds[unit] * multiply)
  }

  date = new Date(date.getTime())
  if (unit === 'year') {
    date.setFullYear(date.getFullYear() + multiply)
  }
  if (unit === 'month') {
    const month = date.getMonth() + multiply
    date.setFullYear(date.getFullYear() + Math.floor(month / 12))
    date.setMonth(month % 12)
  }
  return date
}

export function formatDate(dateInput, format, duration) {
  if (duration) {
    dateInput = parseDate(dateInput)
    dateInput = addDuration(dateInput, duration)
  }
  let options
  if (format === 'time') options = timeFormatOptions
  if (format === 'date') options = dateFormatOptions
  if (format === 'datetime') options = datetimeFormatOptions
  if (!options) throw 'format: time, date, datetime'
  return fullcalendarFormatDate(dateInput, options).replace(/[/年月]/g, '-').replace('日', '')
}
